import { TextField, Typography, InputAdornment, Snackbar, IconButton, withStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { createFactory, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import api from '../api';
import { useLocation } from 'react-router-dom';
import icLocation from '../../assets/ic_location.png';
import icShareLocation from '../../assets/ic_shareLoc.png';
import { format } from 'date-fns';
import CustomTextField from '../components/customTextField';
import { TimePicker, KeyboardDateTimePicker, KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import PopupMap from '../components/popupMap';
import Map from '../components/Map';
import { LoadScript } from "@react-google-maps/api";
import NumberFormat from 'react-number-format';
import Constant from '../../library/Constant';
import { SignalCellularNullSharp, TramRounded, Visibility } from '@material-ui/icons';
import Send from '@material-ui/icons/Send';
import MuiAlert from '@material-ui/lab/Alert';
import { Tooltip } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';

const lib = ["places"];

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}


export default function DetailEmergency(props) {
    const history = useHistory()
    const location = useLocation()
    const [ID, setID] = useState("")
    // const [tglOrder, setTglOrder] = useState(new Date());
    const [tglBooking, setTglBooking] = useState(new Date());
    const [tglBookingAwal, setTglBookingAwal] = useState(new Date());
    const [jamBooking, setJamBooking] = useState(null);
    const [pemesan, setPemesan] = useState("")
    const [noHP, setNoHP] = useState("")
    const [pasien, setPasien] = useState("")
    const [unitClass, setUnitClass] = useState("")
    const [noRM, setNoRM] = useState("")
    const [bookingID, setBookingID] = useState("")
    const [perkiraanKM, setPerkiraanKM] = useState("")
    const [address, setAddress] = useState("")
    const [distance, setDistance] = useState("")
    const [ketAlamat, setKetAlamat] = useState("")
    const listKategori = [
        { value: 'Umum', id: 1 },
        { value: 'Psichiatry', id: 2 },
        { value: 'Isolasi', id: 3 },
    ]
    const [kategori, setKategori] = useState(null)

    // const listBookingType = [
    //     { value: 'Saat Ini', id: 1 },
    //     { value: 'Untuk Nanti', id: 2 },
    // ]
    // const [bookingType, setBookingType] = useState(null)

    const listOrderType = [
        { value: 'Booking', id: 1 },
        { value: 'Maintenance', id: 2 },
    ]
    const [orderType, setOrderType] = useState(null)
    const [status, setStatus] = useState("")
    const [via, setVia] = useState("")

    const [perawat, setPerawat] = useState([])
    const [dataPerawat, setDataPerawat] = useState([])

    const [dataSupir, setDataSupir] = useState([])
    const [supir, setSupir] = useState(null)

    const [dokter, setDokter] = useState([])
    const [dataDokter, setDataDokter] = useState([])

    const [dataAmbulance, setDataAmbulance] = useState([])
    const [ambulance, setAmbulance] = useState(null)

    const [price, setPrice] = useState("")
    const [createAt, setCreateAt] = useState(new Date());
    const [updateAt, setUpdateAt] = useState(new Date());
    const [createBy, setCreateBy] = useState("");
    const [updateBy, setUpdateBy] = useState("");
    const [notes, setNotes] = useState("");

    const [errorPemesan, setErrorPemesan] = React.useState(false);
    const [errorPasien, setErrorPasien] = React.useState(false);
    const [errorHP, setErrorHP] = React.useState(false)
    const [errorAmbulance, setErrorAmbulance] = React.useState(false)
    const [errorJamBerangkat, setErrorJamBerangkat] = React.useState(false)
    const [errorJamPulang, setErrorJamPulang] = React.useState(false)
    const [errorBerangkatActual, setErrorBerangkatActual] = React.useState(false)
    const [errorPulangActual, setErrorPulangActual] = React.useState(false)
    const [errorUnitClass, setErrorUnitClass] = React.useState(false);
    const [errorPrice, setErrorPrice] = React.useState(false);
    const [errorPerawat, setErrorPerawat] = React.useState(false)
    const [errorSupir, setErrorSupir] = React.useState(false)
    const [errorDokter, setErrorDokter] = React.useState(false)

    const [texterrorPemesan, setTextErrorPemesan] = React.useState(null);
    const [texterrorPasien, setTextErrorPasien] = React.useState(null);
    const [texterrorHP, setTextErrorHP] = React.useState(null)
    const [texterrorAmbulance, setTextErrorAmbulance] = React.useState(null)
    const [texterrorJamBerangkat, setTextErrorJamBerangkat] = React.useState(null)
    const [texterrorJamPulang, setTextErrorJamPulang] = React.useState(null)
    const [texterrorBerangkatActual, setTextErrorBerangkatActual] = React.useState(null)
    const [texterrorPulangActual, setTextErrorPulangActual] = React.useState(null)
    const [texterrorUnitClass, setTextErrorUnitClass] = React.useState(null)
    const [texterrorPrice, setTextErrorPrice] = React.useState(null)
    const [texterrorPerawat, setTextErrorPerawat] = React.useState(null)
    const [texterrorSupir, setTextErrorSupir] = React.useState(null)
    const [texterrorDokter, setTextErrorDokter] = React.useState(null)



    const [jamBerangkat, setJamBerangkat] = useState(null);
    const [jamPulang, setJamPulang] = useState(null);
    const [berangkatActual, setBerangkatActual] = useState(null);
    const [pulangActual, setPulangActual] = useState(null);
    const [visibleMap, setvisibleMap] = React.useState(false);
    const [saveDataMap, setSaveDataMap] = React.useState(null);
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [visibleConfirmDone, setVisibleConfirmDone] = React.useState(false);
    const [visibleConfirmCancel, setVisibleConfirmCancel] = React.useState(false);

    const forceUpdate = React.useReducer(bool => !bool)[1];

    useEffect(() => {
        getAmbulance()
        getDokter()
    }, []);

    const getAmbulance = () => {
        api.create().getAmbulance().then(response => {
            console.log(response);
            if (response.data) {
                let dataAmbulance = []
                response.data.data.map(item => {
                    dataAmbulance.push({
                        id: item.id,
                        value: `${item.vehicle_name} - ${item.vehicle_number}`
                    })
                })
                setDataAmbulance(dataAmbulance)
                getDetail(dataAmbulance)
            }
        })
    }

    const getListPetugas = (supir, perawat) => {
        api.create().getListPetugas().then(response => {
            console.log(response);
            if (response.data) {
                let dataSupir = []
                let dataPerawat = []
                response.data.data.map(item => {
                    if (item.deleted_at === null) {
                        if (item.role === "Supir") {
                            dataSupir.push({
                                id: item.id,
                                value: item.name
                            })
                        } else if (item.role === "Perawat") {
                            dataPerawat.push({
                                id: item.id,
                                fullname: item.name
                            })
                        }
                    }
                })
                console.log(supir);
                if (supir) {
                    let idxSupir = dataSupir.findIndex((val) => val.id === supir.id)
                    if (idxSupir > -1) {
                        setSupir(dataSupir[idxSupir])
                    }
                }
                setPerawat(perawat)
                setDataSupir(dataSupir)
                setDataPerawat(dataPerawat)
            }
        })
    }

    const getDokter = () => {
        api.create().getListDokter().then(response => {
            console.log(response);
            if (response.data) {
                let dataDokter = []
                response.data.data.map(item => {
                    if (item.deleted_at === null) {
                        if (item.is_igd === 1) {
                            dataDokter.push({
                                id: item.id,
                                name: item.name
                            })
                        }
                    }
                })
                setDataDokter(dataDokter)
            }
        })
    }


    const getDetail = (cat) => {
        // console.log(location);
        api.create().getDetailEmergency(location.state.id[8]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setID(data.id)
                    // setTglOrder(new Date(data.created_at))
                    setPemesan(data.customer_name)
                    setNoHP(data.phone_number)
                    setPasien(data.patient_name)
                    setNoRM(data.medical_record_no === null ? "" : data.medical_record_no)
                    setBookingID(data.booking_id)
                    setPerkiraanKM(data.estimated_mileage)
                    setAddress(data.address)
                    let dataMap = {
                        address: data.address,
                        lng: data.longitude,
                        lat: data.latitude,
                        jarak: `${Number(data.estimated_mileage).toFixed(1)} km`,
                        distance: data.estimated_mileage
                    }
                    setSaveDataMap(dataMap)
                    console.log(Number(data.estimated_mileage) / 1000);
                    let idx = listKategori.findIndex((val) => val.id === data.order_category)
                    if (idx > -1) {
                        setKategori(listKategori[idx])
                    }
                    // let idx1 = listBookingType.findIndex((val) => val.id === data.booking_type)
                    // if (idx1 > -1) {
                    //     setBookingType(listBookingType[idx1])
                    // }
                    setCreateAt(new Date(data.created_at))
                    setUpdateAt(new Date(data.updated_at))
                    setCreateBy(data.created_by)
                    setUpdateBy(data.updated_by === null ? '-' : data.updated_by)
                    setVia(data.order_via_name)
                    setKetAlamat(data.address_notes === null ? "" : data.address_notes)
                    setNotes(data.notes === null ? "" : data.notes)
                    // console.log(data.ambulance_id);
                    let index_ambulance = cat.findIndex((val) => val.id === data.ambulance_id)
                    if (index_ambulance > -1) {
                        setAmbulance(cat[index_ambulance])
                    }
                    setStatus(data.status === 0 ? "Batal" : data.status === 1 ? "Booking" : data.status === 2 ? "Konfirmasi" : data.status === 3 ? "Selesai" : null)
                    setUnitClass(data.class_unit === null ? "" : data.class_unit)
                    setPrice(data.estimated_price)
                    let idx3 = listOrderType.findIndex((val) => val.id === data.order_type)
                    if (idx3 > -1) {
                        setOrderType(listOrderType[idx3])
                    }
                    setJamBerangkat(data.estimated_departure_time === null ? null : new Date(`2014-08-18T${data.estimated_departure_time}`))
                    setJamPulang(data.estimated_return_time === null ? null : new Date(`2014-08-18T${data.estimated_return_time}`))
                    setBerangkatActual(data.actual_departure_time === null ? null : new Date(`2014-08-18T${data.actual_departure_time}`))
                    setPulangActual(data.actual_return_time === null ? null : new Date(`2014-08-18T${data.actual_return_time}`))
                    setJamBooking(data.booking_time === null ? null : new Date(`2014-08-18T${data.booking_time}`))
                    setTglBooking(new Date(data.booking_date))
                    setTglBookingAwal(new Date(data.booking_date))
                    getListPetugas(data.driver_emergency_user, data.nurse_emergency_user)
                    if (data.doctor) {
                        setDokter(data.doctor)
                    }
                    forceUpdate()
                }
            }
        })
    }

    const handleSave = (tipe) => {
        if (pemesan === "") {
            setErrorPemesan(true)
            setTextErrorPemesan("Nama Pemesan wajib diisi")
        } else if (noHP === "") {
            setErrorHP(true)
            setTextErrorHP("No Handphone wajib diisi")
        } else if (pasien === "") {
            setErrorPasien(true)
            setTextErrorPasien("Nama Pasien wajib diisi")
        } else if (tipe === 3 && unitClass === "") {
            setVisibleConfirmDone(false)
            setErrorUnitClass(true)
            setTextErrorUnitClass("Unit/Kelas wajib diisi")
        } else if (tipe === 3 && ambulance === null) {
            setVisibleConfirmDone(false)
            setErrorAmbulance(true)
            setTextErrorAmbulance("Ambulace wajib diisi")
        } else if (ambulance !== null) {
            if (tipe === 3 && price === "0") {
                setVisibleConfirmDone(false)
                setErrorPrice(true)
                setTextErrorPrice("Perkiraan Harga wajib diisi")
            } else if (jamBerangkat === null) {
                setVisibleConfirmDone(false)
                setErrorJamBerangkat(true)
                setTextErrorJamBerangkat("Perkiraan Jam Berangkat wajib diisi")
            } else if (jamPulang === null) {
                setVisibleConfirmDone(false)
                setErrorJamPulang(true)
                setTextErrorJamPulang("Perkiraan Jam Pulang wajib diisi")
            } else if (tipe === 3 && berangkatActual === null) {
                setVisibleConfirmDone(false)
                setErrorBerangkatActual(true)
                setTextErrorBerangkatActual("Jam Berangkat Actual wajid diisi")
            } else if (tipe === 3 && pulangActual === null) {
                setVisibleConfirmDone(false)
                setErrorPulangActual(true)
                setTextErrorPulangActual("Jam Pulang Actual wajid diisi")
            } else if (tipe === 3 && perawat.length < 1) {
                setVisibleConfirmDone(false)
                setErrorPerawat(true)
                setTextErrorPerawat("Perawat wajib diisi")
            } else if (tipe === 3 && supir === null) {
                setVisibleConfirmDone(false)
                setErrorSupir(true)
                setTextErrorSupir("Supir wajib diisi")
            } else {
                let nurse = []
                if (perawat.length > 0) {
                    perawat.map(item => {
                        nurse.push(item.id)
                    })
                }
                let doctor = []
                if (dokter.length > 0) {
                    dokter.map(item => {
                        doctor.push(item.id)
                    })
                }
                let payload = {
                    "emergency_id": ID,
                    "ambulance_id": ambulance === null ? null : ambulance.id,
                    "customer_name": pemesan,
                    "phone_number": noHP,
                    "patient_name": pasien,
                    "medical_record_no": noRM,
                    "booking_date": format(new Date(tglBooking), 'yyyy-MM-dd'),
                    "booking_time": format(new Date(jamBooking), 'HH:mm:ss'),
                    "order_category": kategori.id,
                    "address": saveDataMap === null ? '' : saveDataMap.address,
                    "latitude": saveDataMap === null ? '' : saveDataMap.lat,
                    "longitude": saveDataMap === null ? '' : saveDataMap.lng,
                    "estimated_mileage": saveDataMap === null ? '' : Number(saveDataMap.distance).toFixed(1),
                    "order_type": orderType === null ? null : orderType.id,
                    "class_unit": unitClass,
                    "estimated_departure_time": jamBerangkat === null ? null : format(new Date(jamBerangkat), 'HH:mm:ss'),
                    "estimated_return_time": jamPulang === null ? null : format(new Date(jamPulang), 'HH:mm:ss'),
                    "actual_departure_time": berangkatActual === null ? null : format(new Date(berangkatActual), 'HH:mm:ss'),
                    "actual_return_time": pulangActual === null ? null : format(new Date(pulangActual), 'HH:mm:ss'),
                    "estimated_price": price === null ? 0 : price === "" ? 0 : price,
                    "is_admin": 1,
                    "notes": notes,
                    "status": tipe,
                    "address_notes": ketAlamat,
                    "nurse_emergency_user_id": nurse,
                    "driver_emergency_user_id": supir && supir.id,
                    "doctor_id": doctor
                }
                console.log(payload);
                api.create().updateEmergency(payload).then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            history.goBack()
                        } else {
                            if (response.data.data) {
                                setMessageAlert(response.data.data)
                                setStatusAlert('warning')
                                setOpenAlert(true)
                            }
                        }
                    }
                })
            }
        } else {
            let nurse = []
            if (perawat.length > 0) {
                perawat.map(item => {
                    nurse.push(item.id)
                })
            }
            let doctor = []
            if (dokter.length > 0) {
                dokter.map(item => {
                    doctor.push(item.id)
                })
            }
            let payload = {
                "emergency_id": ID,
                "ambulance_id": ambulance === null ? null : ambulance.id,
                "customer_name": pemesan,
                "phone_number": noHP,
                "patient_name": pasien,
                "medical_record_no": noRM === null ? "" : noRM,
                "booking_date": format(new Date(tglBooking), 'yyyy-MM-dd'),
                "booking_time": format(new Date(jamBooking), 'HH:mm:ss'),
                "order_category": kategori.id,
                "address": saveDataMap === null ? '' : saveDataMap.address,
                "latitude": saveDataMap === null ? '' : saveDataMap.lat,
                "longitude": saveDataMap === null ? '' : saveDataMap.lng,
                "estimated_mileage": saveDataMap === null ? '' : Number(saveDataMap.distance).toFixed(1),
                "order_type": orderType === null ? null : orderType.id,
                "class_unit": unitClass === null ? "" : unitClass,
                "estimated_departure_time": jamBerangkat === null ? null : format(new Date(jamBerangkat), 'HH:mm:ss'),
                "estimated_return_time": jamPulang === null ? null : format(new Date(jamPulang), 'HH:mm:ss'),
                "actual_departure_time": berangkatActual === null ? null : format(new Date(berangkatActual), 'HH:mm:ss'),
                "actual_return_time": pulangActual === null ? null : format(new Date(pulangActual), 'HH:mm:ss'),
                "estimated_price": price === null ? 0 : price === "" ? 0 : price,
                "is_admin": 1,
                "notes": notes === null ? "" : notes,
                "status": tipe,
                "address_notes": ketAlamat === null ? "" : ketAlamat,
                "nurse_emergency_user_id": nurse,
                "driver_emergency_user_id": supir && supir.id,
                "doctor_id": doctor
            }
            console.log(payload);
            api.create().updateEmergency(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        history.goBack()
                    } else {
                        if (response.data.data) {
                            setMessageAlert(response.data.data)
                            setStatusAlert('warning')
                            setOpenAlert(true)
                        }
                    }
                }
            })
        }

    }

    const handleCancel = (tipe) => {
        if (pemesan === "") {
            setErrorPemesan(true)
            setTextErrorPemesan("Nama Pemesan wajib diisi")
        } else if (noHP === "") {
            setErrorHP(true)
            setTextErrorHP("No Handphone wajib diisi")
        } else if (pasien === "") {
            setErrorPasien(true)
            setTextErrorPasien("Nama Pasien wajib diisi")
        } else {
            let nurse = []
            if (perawat !== null) {
                perawat.map(item => {
                    nurse.push(item.id)
                })
            }
            let doctor = []
            if (dokter !== null) {
                dokter.map(item => {
                    doctor.push(item.id)
                })
            }
            let payload = {
                "emergency_id": ID,
                "ambulance_id": ambulance === null ? null : ambulance.id,
                "customer_name": pemesan,
                "phone_number": noHP,
                "patient_name": pasien,
                "medical_record_no": noRM === null ? "" : noRM,
                "booking_date": format(new Date(tglBooking), 'yyyy-MM-dd'),
                "booking_time": format(new Date(jamBooking), 'HH:mm:ss'),
                "order_category": kategori.id,
                "address": saveDataMap === null ? '' : saveDataMap.address,
                "latitude": saveDataMap === null ? '' : saveDataMap.lat,
                "longitude": saveDataMap === null ? '' : saveDataMap.lng,
                "estimated_mileage": saveDataMap === null ? '' : Number(saveDataMap.distance).toFixed(1),
                "order_type": orderType === null ? null : orderType.id,
                "class_unit": unitClass === null ? "" : unitClass,
                "estimated_departure_time": jamBerangkat === null ? null : format(new Date(jamBerangkat), 'HH:mm:ss'),
                "estimated_return_time": jamPulang === null ? null : format(new Date(jamPulang), 'HH:mm:ss'),
                "actual_departure_time": berangkatActual === null ? null : format(new Date(berangkatActual), 'HH:mm:ss'),
                "actual_return_time": pulangActual === null ? null : format(new Date(pulangActual), 'HH:mm:ss'),
                "estimated_price": price === null ? 0 : price === "" ? 0 : price,
                "is_admin": 1,
                "notes": notes,
                "status": tipe,
                "address_notes": ketAlamat,
                "nurse_emergency_user_id": nurse,
                "driver_emergency_user_id": supir && supir.id,
                "doctor_id": doctor
            }
            console.log(saveDataMap);

            api.create().updateEmergency(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        history.goBack()
                    }
                }
            })
        }

    }

    const directLink = () => {
        let a = saveDataMap.address.split(',').join('').split(' ').join('+')
        console.log(a);
        let uri = `https://www.google.com/maps/search/?api=1&query=${saveDataMap.lat},${saveDataMap.lng}`
        var el = document.createElement('textarea');
        // Set value (string to be copied)
        el.value = uri;
        // Set non-editable to avoid focus and move outside of view
        el.setAttribute('readonly', '');
        el.style = { position: 'absolute', left: '-9999px' };
        document.body.appendChild(el);
        // Select text inside element
        el.select();
        // Copy text to clipboard
        document.execCommand('copy');
        // Remove temporary element
        document.body.removeChild(el);
        setOpenAlert(true)
        setStatusAlert("success")
        setMessageAlert('Copied!')
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    return (
        <div style={{ maxHeight: props.height - 80, width: '100%', overflow: 'scroll', padding: '20px 0px' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '100%' }}>
                    <Typography style={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Data Pemesan</Typography>
                    <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 40 }}>
                        {/* <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker
                                        value={tglOrder}
                                        readOnly={true}
                                        label="Tanggal & Jam Order"
                                        onError={console.log}
                                        // minDate={new Date()}
                                        ampm={false}
                                        format="dd/MM/yyyy  HH:mm "
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div> */}
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    value={pemesan}
                                    required={true}
                                    label="Nama Pemesan"
                                    error={errorPemesan}
                                    helperText={texterrorPemesan}
                                    onChange={(val) => {
                                        setPemesan(val)
                                        setErrorPemesan(false)
                                        setTextErrorPemesan("")
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                        <div className="column-2">
                            <div>
                                <TextField
                                    style={{ width: '90%' }}
                                    id="noHp"
                                    name="noHp"
                                    label="No. Handphone"
                                    required={true}
                                    error={errorHP}
                                    helperText={texterrorHP}
                                    value={noHP || ""}
                                    // placeholder={"input No hp pasien"}
                                    onChange={(e) => {
                                        setNoHP(e.target.value)
                                        setErrorHP(false)
                                        setTextErrorHP(null)
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputProps={{
                                        maxLength: 12,
                                        startAdornment: <InputAdornment position="start" style={{ margin: 0, marginRight: 5, fontSize: 14, }}>+62</InputAdornment>,
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 16,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    value={pasien}
                                    required={true}
                                    label="Nama Pasien"
                                    error={errorPasien}
                                    helperText={texterrorPasien}
                                    onChange={(val) => {
                                        setPasien(val)
                                        setErrorPasien(false)
                                        setTextErrorPasien("")
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    value={noRM}
                                    label="No RM"
                                    onChange={(val) => {
                                        setNoRM(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <Typography style={{ color: 'black', fontWeight: '500', marginTop: 15, fontFamily: 'Poppins' }}>Detail Pesanan</Typography>
                    <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 40 }}>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    value={bookingID}
                                    label="Kode Booking"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    options={listKategori}
                                    getOptionLabel={(option) => option.value}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setKategori(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Kategori Pesanan'}
                                        />
                                    }
                                    value={kategori}
                                />
                            </div>
                        </div>
                        {/* <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    options={listOrderType}
                                    getOptionLabel={(option) => option.value}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setOrderType(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Tipe Pesanan'}
                                        />
                                    }
                                    value={orderType}
                                />
                            </div>
                        </div> */}

                        {/* {orderType &&
                            orderType.id === 2 && ( */}
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="tanggal"
                                        label="Tanggal Pesanan"
                                        required={true}
                                        format="dd/MM/yyyy"
                                        value={tglBooking}
                                        minDate={format(new Date(tglBookingAwal), 'yyyyMMdd') < format(new Date(), 'yyyyMMdd') ? new Date(tglBookingAwal) : new Date()}
                                        onChange={(date) => {
                                            setTglBooking(date)
                                            forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '100%', margin: 0 }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                        {/* )} */}

                        {/* {orderType &&
                            orderType.id === 2 && ( */}
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        label="Jam Pesanan"
                                        value={jamBooking}
                                        onChange={setJamBooking}
                                        style={{ width: '100%' }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                        {/* )
                        } */}

                        <div className="column-1" style={{ width: '90%' }}>
                            <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                <CustomTextField
                                    label="Alamat Pesanan"
                                    // disabled={true}
                                    value={saveDataMap !== null ? saveDataMap.address : address}
                                    onClick={() => setvisibleMap(true)}
                                    InputProps={{
                                        readOnly: true,
                                        style: {
                                            color: '#347AF0'
                                        },
                                        startAdornment: <InputAdornment position="start" style={{ marginRight: 0 }}>
                                            <div style={{ display: 'flex', }}>
                                                <IconButton
                                                    style={{ marginRight: 0 }}
                                                    aria-label="toggle password visibility"
                                                    // onClick={() => setvisibleMap(true)}
                                                    edge="start"
                                                >
                                                    <img src={icLocation} style={{ width: 20, height: 20 }} />
                                                </IconButton>
                                            </div>
                                        </InputAdornment>,
                                    }}
                                />
                                <div style={{ display: 'flex', marginTop: 18, borderBottom: '1px solid rgb(148 148 148)' }}>
                                    {saveDataMap !== null && (
                                        <LightTooltip title={"Share Lokasi"} arrow>
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                style={{ outline: 'none', margin: 0, padding: 0, marginBottom: 5 }}
                                                onClick={() => directLink()}
                                                edge="end"
                                            >
                                                <img src={icShareLocation} style={{ marginLeft: 10, width: 23, height: 23 }} />
                                            </IconButton>
                                        </LightTooltip>
                                    )}
                                </div>
                            </div>

                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    value={saveDataMap !== null ? saveDataMap.jarak : perkiraanKM}
                                    // required={true}
                                    disabled={true}
                                    label="Perkiraan KM"
                                    onChange={(val) => {
                                        setPerkiraanKM(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>

                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    label="Keterangan Alamat"
                                    multiline
                                    value={ketAlamat}
                                    onChange={(val) => {
                                        setKetAlamat(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <Typography style={{ color: 'black', fontWeight: '500', marginTop: 15, fontFamily: 'Poppins' }}>Detail Konfirmasi</Typography>
                    <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 40 }}>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    options={listOrderType}
                                    getOptionLabel={(option) => option.value}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setOrderType(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Jenis Pesanan'}
                                        />
                                    }
                                    value={orderType}
                                />
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    value={unitClass}
                                    label="Unit/Kelas"
                                    error={errorUnitClass}
                                    helperText={texterrorUnitClass}
                                    onChange={(val) => {
                                        setUnitClass(val)
                                        setErrorUnitClass(false)
                                        setTextErrorUnitClass("")
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    options={dataAmbulance}
                                    getOptionLabel={(option) => option.value}
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setAmbulance(newInputValue)
                                        setErrorAmbulance(false)
                                        setTextErrorAmbulance("")
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            // required={status === "Konfirmasi" ? true : false}
                                            error={errorAmbulance}
                                            helperText={texterrorAmbulance}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Mobil Ambulance'}
                                        />
                                    }
                                    value={ambulance}
                                />
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    value={price}
                                    label="Perkiraan Harga"
                                    error={errorPrice}
                                    helperText={texterrorPrice}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                    onChange={(val) => {
                                        setPrice(val)
                                        setErrorPrice(false)
                                        setTextErrorPrice("")
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        required={ambulance !== null ? true : false}
                                        label="Perkiraan Jam Berangkat"
                                        error={errorJamBerangkat}
                                        helperText={texterrorJamBerangkat}
                                        value={jamBerangkat}
                                        onChange={(val) => {
                                            setErrorJamBerangkat(false)
                                            setTextErrorJamBerangkat("")
                                            setJamBerangkat(val)
                                            forceUpdate()
                                        }}
                                        style={{ width: '100%' }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        required={ambulance !== null ? true : false}
                                        label="Perkiraan Jam Pulang"
                                        error={errorJamPulang}
                                        helperText={texterrorJamPulang}
                                        value={jamPulang}
                                        onChange={(val) => {
                                            setJamPulang(val)
                                            setErrorJamPulang(false)
                                            setTextErrorJamPulang("")
                                            forceUpdate()
                                        }}
                                        style={{ width: '100%' }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        label="Jam Berangkat Actual"
                                        value={berangkatActual}
                                        error={errorBerangkatActual}
                                        helperText={texterrorBerangkatActual}
                                        onChange={(val) => {
                                            setBerangkatActual(val)
                                            setErrorBerangkatActual(false)
                                            setTextErrorBerangkatActual("")
                                            forceUpdate()
                                        }}
                                        // onChange={setBerangkatActual}
                                        style={{ width: '100%' }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        ampm={false}
                                        label="Jam Pulang Actual"
                                        value={pulangActual}
                                        error={errorPulangActual}
                                        helperText={texterrorPulangActual}
                                        onChange={(val) => {
                                            setPulangActual(val)
                                            setErrorPulangActual(false)
                                            setTextErrorPulangActual("")
                                            forceUpdate()
                                        }}
                                        // onChange={setPulangActual}
                                        style={{ width: '100%' }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </div>

                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    value={status}
                                    label="Status"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </div>
                        </div>

                        <div className="column-2" style={{ width: '90%' }}>
                            <div>
                                <CustomTextField
                                    label="Catatan Lainnya"
                                    value={notes}
                                    onChange={(val) => {
                                        setNotes(val)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <Typography style={{ color: 'black', fontWeight: '500', marginTop: 15, fontFamily: 'Poppins' }}>Detail Petugas</Typography>
                    <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 40 }}>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    multiple
                                    options={dataPerawat}
                                    getOptionLabel={(option) => option.fullname}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setPerawat(newInputValue)
                                        setErrorPerawat(false)
                                        setTextErrorPerawat("")
                                        // setErrorSupir(false)
                                        // setTextErrorSupir("")
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            // required={ambulance !== null ? true : false}
                                            helperText={texterrorPerawat}
                                            error={errorPerawat}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Perawat'}
                                        />
                                    }
                                    value={perawat}
                                />
                            </div>
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <Autocomplete
                                options={dataSupir}
                                getOptionLabel={(option) => option.value}
                                // disableClearable
                                style={{ width: '100%' }}
                                onChange={(event, newInputValue) => {
                                    setSupir(newInputValue)
                                    setErrorSupir(false)
                                    setTextErrorSupir("")
                                    // setErrorPerawat(false)
                                    // setTextErrorPerawat("")
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        // required={ambulance !== null ? true : false}
                                        helperText={texterrorSupir}
                                        error={errorSupir}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        label={'Supir'}
                                    />
                                }
                                value={supir}
                            />
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <div>
                                <Autocomplete
                                    multiple
                                    options={dataDokter}
                                    getOptionLabel={(option) => option.name}
                                    disableClearable
                                    style={{ width: '100%' }}
                                    onChange={(event, newInputValue) => {
                                        setDokter(newInputValue)
                                        setErrorDokter(false)
                                        setTextErrorDokter("")
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label={'Dokter'}
                                            // required={ambulance !== null ? true : false}
                                            helperText={texterrorDokter}
                                            error={errorDokter}
                                        />
                                    }
                                    value={dokter}
                                />
                            </div>
                        </div>
                    </div>
                    <Typography style={{ color: 'black', fontWeight: '500', fontFamily: 'Poppins' }}>Status</Typography>
                    <div className="grid grid-2x gap-20px" style={{ padding: 20, paddingRight: 40, paddingLeft: 40 }}>
                        <div className="column-1" style={{ width: '90%' }}>
                            <TextField
                                label="Created Date"
                                value={format(new Date(createAt), 'yyyy-MM-dd HH:mm:ss')}
                                style={{ width: '100%' }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <TextField
                                label="Created By"
                                value={createBy}
                                style={{ width: '100%' }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <TextField
                                label="Updated Date"
                                value={format(new Date(updateAt), 'yyyy-MM-dd HH:mm:ss')}
                                style={{ width: '100%' }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                        </div>
                        <div className="column-2" style={{ width: '90%' }}>
                            <TextField
                                label="Updated By"
                                value={updateBy}
                                style={{ width: '100%' }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                        </div>
                        <div className="column-1" style={{ width: '90%' }}>
                            <TextField
                                label="Order By"
                                value={via}
                                style={{ width: '100%' }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 18,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black'
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid grid-2x" style={{ height: 56, paddingLeft: 20, paddingRight: 20 }}>
                <div className="column-1" style={{ alignSelf: 'center' }}>
                    <div
                        style={{ backgroundColor: 'red', marginRight: 10, width: 120, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                        onClick={() => {
                            setVisibleConfirmCancel(true)
                            // console.log(content);
                            // console.log(String(content).indexOf("*"));
                        }}>
                        <Typography style={{ color: 'white' }}>Batal</Typography>
                    </div>
                </div>
                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <div
                        style={{ backgroundColor: '#2a9c6c', marginRight: 10, width: 120, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                        onClick={() => handleSave(2)}>
                        <Typography style={{ color: 'white' }}>Konfirmasi</Typography>
                    </div>

                    <div
                        style={{ backgroundColor: status === 'Booking' ? 'grey' : 'blue', width: 120, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: status === 'Booking' ? 'default' : 'pointer' }}
                        onClick={() => status === 'Booking' ? null : setVisibleConfirmDone(true)}>
                        <Typography style={{ color: 'white' }}>Selesai</Typography>
                    </div>
                </div>
            </div>
            {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>

            </div> */}

            {visibleMap && (
                <LoadScript googleMapsApiKey={Constant.API_KEY_GOOGLE} libraries={lib}>
                    <Map
                        onClose={() => setvisibleMap(false)}
                        setSaveDataMap={(val) => {
                            setSaveDataMap(val)
                        }}
                        saveDataMap={saveDataMap}
                    />
                </LoadScript>
            )}
            {visibleConfirmDone && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleConfirmDone(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}> Anda tidak dapat mengubah data kembali. Apakah anda yakin SELESAI transaksi ini</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleConfirmDone(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => handleSave(3)}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }

            {visibleConfirmCancel && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleConfirmCancel(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda tidak dapat mengubah data kembali. Apakah anda yakin BATAL transaksi ini</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleConfirmCancel(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => handleCancel(0)}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    )
}